import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { CREATE_EXERCISE } from '../redux/exercisesReducer'

interface Props {
  toggleModal: () => void
}

const TypeAnswerQuestion = ({ toggleModal }: Props) => {
  const [question, setQuestion] = useState('')
  const [answer, setAnswer] = useState('')
  const dispatch = useDispatch()
  const { lessonPlanId } = useParams()

  const handleSubmit = () => {
    dispatch(CREATE_EXERCISE({ question, answer, lessonPlanId: Number(lessonPlanId), question_type: 'type_answer' }))
    toggleModal()
  }

  return (
    <>
      <div className="h-4" />
      <div>
        <div className="text-14 font-medium">Question</div>
        <div className="h-2" />
        <input
          className="w-full border border-lightBorder/10 rounded-lg p-2"
          value={question}
          onChange={(e) => setQuestion(e.target.value)}
        />
      </div>
      <div className="h-4" />
      <div>
        <div className="text-14 font-medium">Answer</div>
        <div className="h-2" />
        <input
          className="w-full border border-lightBorder/10 rounded-lg p-2"
          value={answer}
          onChange={(e) => setAnswer(e.target.value)}
        />
      </div>
      <div className="h-6" />
      <div className="flex justify-end">
        <button onClick={handleSubmit} className="bg-slateGray text-white rounded-lg px-4 py-2">
          Add Exercise
        </button>
      </div>
    </>
  )
}

export default TypeAnswerQuestion
